import React from "react";
import "./sponsorHeader.scss";

class SponsorHeader extends React.Component {
  render() {
    return (
      <header id="sponsor-header" className="container-fluid-info">
        <a href={this.props.sponsorUrl}>
        <div
          className="sponsor-image"
          style={{ backgroundImage: `url(${this.props.sponsorImageUrl})` }}
        />
        </a>
        <span className="sponsor-text">
          Created in partnership with and paid for by our sponsor.{" "}
          <a href={this.props.sponsorUrl}>Learn more</a>
        </span>
      </header>
    );
  }
}

export default SponsorHeader;
